/* @flow */

import { useSelector, shallowEqual } from 'react-redux';

import { getSelf } from 'src/shared/domain/user/selector/userSelectors';

import type { User } from '@braindate/domain/lib/user/type';

export default function useSelf(): ?User {
  // User schema doesn't depend on any other data for now, but the `getSelf`
  // selector returns a new user object whenever a part of the `entities` state
  // slice changes. Therefore it returns a new user object whenever the
  // entities are modified, even if the user data hasn't changed. To mitigate
  // that, we use a shallow comparison instead of the default strict comparison
  // of react-redux.
  return useSelector(getSelf, shallowEqual);
}
